module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f000i-01.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sidebarfm"
  }, [_c('p', {
    staticClass: "noindentfm"
  }, [_vm._v("The original crew of the ‘Memphis Belle’ left to right: Technical Sergeant Harold P. Loch, top turret gunner Staff Sergeant Cecil H. Scott, ball turret gunner Technical Sergeant Robert J, Hanson, radio operator Captain James A. Verinis, co-pilot Captain Robert K. Morgan, pilot Captain Charles B. Leighton, navigator Staff Sergeant John P. Quinlan, tail gunner Staff Sergeant Casimer A. Nastal, waist gunner Captain Vincent B. Evans, bombardier and Staff Sergeant Clarence E. Winchell.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c1f0390","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Fm01.vue
// module id = 60
// module chunks = 0